const state = {
   incomingOrderProducts:{},
}

export default state
